import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const ItineraryItemStyle = styled('div')`
    margin-top: 24px;
    .day-title {
        color: var(--sand-700);
        ${typography.subhead}
        padding: 8px 0;

        ${media.mobile} {
            font-size: 24px;
            letter-spacing: -0.02em;
        }
    }

    @media print {
        .day-title {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-top:24px;
        }
    }
`;
export default ItineraryItemStyle;